// extracted by mini-css-extract-plugin
module.exports = {"fill-parent":"fill-parent__5PnZz","nav-item":"nav-item__EWmBk","nav-item__link":"nav-item__link__3qDLd","nav-item__link--active":"nav-item__link--active__185qc"};